
const common = {
  state: {
    mapBackground: 'amap://styles/b4d85404c87bf44eab746d6bf2138e17' // 地图图层
  },
  mutations: {
    // SET_PROJECTID: (state, projectId) => {
    //   state.projectId = projectId
    // }
  },
  actions: {
    // setProjectId ({ commit }, projectId) {
    //   commit('SET_PROJECTID', projectId)
    // }
  }
}

export default common
